/**
 =========================================================
 * Material Dashboard 2 PRO React - v2.1.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
 * Copyright 2022 Creative Tim (https://www.creative-tim.com)

 Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

import checkout from "./form";

const {
    formField: {
        name,
        street,
        exterior_number,
        interior_number,
        suburb,
        postal_code,
        city,
        state
    },
} = checkout;

const initialValues = {
    [name.name]: "",
    [street.name]: "",
    [exterior_number.name]: "",
    [interior_number.name]: "",
    [suburb.name]: "",
    [postal_code.name]: "",
    [city.name]: "",
    [state.name]: "",
};

export default initialValues;
